import { render, staticRenderFns } from "./GuestBirthDay.vue?vue&type=template&id=207f1bf6"
import script from "./GuestBirthDay.vue?vue&type=script&lang=js"
export * from "./GuestBirthDay.vue?vue&type=script&lang=js"
import style0 from "./GuestBirthDay.vue?vue&type=style&index=0&id=207f1bf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../and-iot-pre-checkin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports